import {faEye,faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect, useState } from 'react';
import {useNavigate} from 'react-router-dom';
import { AdminAuthContext } from '../../Auth/AdminAuthProvider';
import AdminService from '../../services/AdminService';
export default function Register() {
  const [passwordVisibility,setPasswordVisibility] = useState(false);
  const [adminData,setAdminData] = useState({});
  const navigator = useNavigate();
  const [errors,setErrors] = useState({});
  const [errorBackend,setErrorBackend] = useState("");
  const adminAuth = useContext(AdminAuthContext)
  const updateAdminData = (e) => {
    setAdminData(prev=>({
      ...prev,
      [e.target.name]:e.target.value,
    }));
    setErrors(prev=>({
      ...prev,
      [e.target.name]:false,
    }));
  }
  useEffect(()=>{
    adminAuth.getData();
    if(Object.keys(adminAuth.adminData).length>0) {
      navigator("/admin/products-list");
    }
  },[adminAuth])
  const logIn = () => {
    const currentError = {};
    if(!adminData.userName || adminData.userName === "") currentError.userName = true;
    if(!adminData.password || adminData.password === "") currentError.password = true;
    setErrors(currentError);
    if(Object.keys(currentError).length === 0) {
      AdminService.login(adminData).then((res)=>{
        adminAuth.getData();
        navigator("/admin/products-list");
      }).catch((err)=>{
        setErrorBackend(err.response.data.errorMessage);
      })
    }
  }
  return (
    <>
      <div className="dark:bg-neutral-700 font-bold flex flex-col items-center w-full max-w-lg m-auto justify-center min-h-[60vh] overflow-hidden bg-amber-50 shadow-lg p-4 sm:p-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-black dark:text-white mb-4 sm:mb-6 text-center">Admin Log In</h2>
        <form className="w-full bg-white dark:bg-neutral-800 dark:shsdow-xl  rounded-lg shadow p-4 sm:p-6 space-y-4 sm:space-y-5">
          <div className="w-full bg-red-800 text-red-400 text-3xl text-center">
            {errorBackend}
          </div>
          <div>
            <label className="block text-black dark:text-white font-semibold mb-1 sm:mb-2" htmlFor="title">
              User Name / email
            </label>
            <input type="text" id="userName" name="userName" onChange={updateAdminData} placeholder="enter your user name / email" className={`border ${errors.userName? 'border-red-300' : 'border-amber-300'} dark:bg-gray-600 bg-white dark:text-white w-full px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-amber-400`}/>
          </div>
          <div>
            <label className="block text-black dark:text-white font-semibold mb-1 sm:mb-2" htmlFor="title">
              Password
            </label>
            <div className="flex flex-row">
              <input type={`${passwordVisibility? 'text' : 'password'}`} id="password" name="password" onChange={updateAdminData} placeholder="enter your Password" className={`w-[90%] border ${errors.password? 'border-red-300' : 'border-amber-300'} dark:bg-gray-600 dark:text-white bg-white px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-amber-400`}/>
              <div className="bg-amber-700 w-[10%] text-white flex items-center justify-center">
                <FontAwesomeIcon icon={passwordVisibility? faEye : faEyeSlash} onClick={()=>setPasswordVisibility(prev=>!prev)} className="text-2xl hover:cursor-pointer" />
              </div>
            </div>
          </div>
          <button type="button" onClick={logIn} className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-2 px-4 rounded transition">
            Log In
          </button>
        </form>
      </div>
      </>
  )
}
